module.exports = __webpack_public_path__ + "img/1755.21341d50.gif";